import { render } from "./TemporaryPassword.vue?vue&type=template&id=62cb80b0&scoped=true"
import script from "./TemporaryPassword.vue?vue&type=script&lang=js"
export * from "./TemporaryPassword.vue?vue&type=script&lang=js"

import "./TemporaryPassword.vue?vue&type=style&index=0&id=62cb80b0&scoped=true&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cb80b0"]])

export default __exports__